import React, { useState } from "react";
import { Button, MenuItem, Paper, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export default function CustomCategoryButton() {
  const [open, setOpen] = useState(false);

  return (
    <Box
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      sx={{  position: "relative", zIndex: 10, marginTop:'6px', display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                }, }}
    >
      {/* Button */}
      <Button
        variant="contained"
        startIcon={open ? <CloseIcon /> : <MenuIcon />}
        sx={{
          background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
          borderRadius: "8px",
          textTransform: "none",
          px: 3,
          py: 1,
          fontWeight: 400,
          fontSize:'14px',
          "&:hover": {
            background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
          },
        }}
      >
        All Categories
      </Button>

      {/* Dropdown */}
      {open && (
        <Paper
          elevation={5}
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            minWidth: 220,
            borderRadius: "8px",
            p: 1,
            bgcolor: "#000", // ✅ Black background
          }}
        >
          <MenuItem
            sx={{
              color: "#fff",
              borderRadius: "6px",
              "&:hover": {
                bgcolor: "#1a1a1a",
              },
            }}
          >
            Category 1
          </MenuItem>

          <MenuItem
            sx={{
              color: "#fff",
              borderRadius: "6px",
              "&:hover": {
                bgcolor: "#1a1a1a",
              },
            }}
          >
            Category 2
          </MenuItem>

          <MenuItem
            sx={{
              color: "#fff",
              borderRadius: "6px",
              "&:hover": {
                bgcolor: "#1a1a1a",
              },
            }}
          >
            Category 3
          </MenuItem>
        </Paper>
      )}
    </Box>
  );
}
